// extracted by mini-css-extract-plugin
export default {"helpIcon":"Help_helpIcon__XdRuQ"};